export class ContactUsFormViewModel {
    public name: string;
    public company?: string;
    public email: string;
    public phone?: string;
    public postalCode: string;
    public country: string;
    public message: string;

    constructor() {
        this.name = '';
        this.email = '';
        this.postalCode = '';
        this.country = '';
        this.message = '';
    }
}
